import { Icon as ChakraIcon } from '@chakra-ui/react';

export const Icon = ChakraIcon;
